import { Text } from '@/components/DesignSystem';
import { Box, ButtonBase } from '@mui/material';
import { useLayoutEffect, useRef } from 'react';
import './DatePickerStyles.css';

export interface DropdownGridPickerItem {
  id: string,
  isDisabled: boolean,
  label: string,
  value: number,
}

interface DropdownGridPickerProps {
  height: number,
  items: DropdownGridPickerItem[],
  onSelect: (value: number) => void,
  selectedValue: number,
}

const COLUMNS = 4;

const itemStyle = {
  borderRadius: '100px',
  height: 36,
  width: 72,
};

export const DropdownGridPicker = ({
  height,
  items,
  onSelect,
  selectedValue,
}: DropdownGridPickerProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const selectedRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const selected = selectedRef.current;
    if (container && selected) {
      const centringOffset = (container.clientHeight - selected.clientHeight) / 2;
      container.scrollTop = selected.offsetTop - centringOffset;
    }
  }, []);

  return (
    <Box
      className="scrollable-container dropdown-grid-picker"
      ref={containerRef}
      sx={{
        alignContent: 'start',
        display: 'grid',
        gridTemplateColumns: `repeat(${COLUMNS}, 1fr)`,
        height,
        overflowY: 'auto',
        position: 'relative',
        px: 2,
        rowGap: 1,
      }}
    >
      {items.map((item) => {
        const isSelected = item.value === selectedValue;
        return (
          <Box
            id={item.id}
            key={item.id}
            ref={isSelected ? selectedRef : undefined}
            sx={{ display: 'flex', justifyContent: 'center', py: 0.5 }}
          >
            <ButtonBase
              aria-pressed={isSelected}
              className={isSelected ? 'dropdown-grid-item-selected' : 'dropdown-grid-item'}
              disabled={item.isDisabled}
              onClick={() => onSelect(item.value)}
              sx={itemStyle}
            >
              <Text category="body-large">{item.label}</Text>
            </ButtonBase>
          </Box>
        );
      })}
    </Box>
  );
};
